import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../../../common/common.model';

export interface ExtRegionItem {
    tenantId: number;
    regionId: number;
    regionDefaultInitials: string;
    regionDefaultShortName: string;
    regionDefaultName: string;
    clientTranslationId: number;
    enabled: boolean;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: number;
    lastUpdatedOn: string;
    languageID: number;
}

export interface RegionItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
}

export class RegionItemModelTransformer
    implements ModelTransformer<RegionItem, ExtRegionItem>
{
    transform(model: ExtRegionItem): RegionItem {
        return {
            id: model.regionId,
            initials: model.regionDefaultInitials,
            shortName: model.regionDefaultShortName,
            name: model.regionDefaultName,
        };
    }
}

export class RegionItemModelSetTransformer extends ModelSetTransformer<
    RegionItem,
    ExtRegionItem
> {
    protected newTransformer(): ModelTransformer<RegionItem, ExtRegionItem> {
        return new RegionItemModelTransformer();
    }
}
